import { RouteConfig } from 'vue-router'

const tiktracRoutes: RouteConfig = {
  path: '/tiktrac',
  name: 'Tiktrac',
  component: () => import('@/apps/tiktrac/views/user/Timetracking.vue'),
}
export default tiktracRoutes
